import { apiCaller } from '@/api/apiCaller';
import { IProfile } from '@/modules/profile/models';
import { apihost } from '@/api/urls';

const getAll = (isOnlyActive: boolean) => apiCaller.getParams('/profile/', apihost, { IsOnlyActive: isOnlyActive });
const addProfile = (profile: IProfile) => apiCaller.post('/profile/save', apihost, profile);
const updateProfile = (profile: IProfile) => apiCaller.put('/profile/update', apihost, profile);
const getProfileFunctionalities = (id: number) => apiCaller.get(`/profilefunctionality/${id}`, apihost);
const getProfileFunctionalitiesGrouped = (ids: string) => apiCaller.get(`/profilefunctionality/grouped/${ids}`, apihost);
const getProfileFunctionalitiesReport = (isOnlyActive: boolean) => apiCaller.getFile(`/profilefunctionality/report?IsOnlyActive=${isOnlyActive}`, apihost);

export const profileApi = {
    getAll,
    addProfile,
    updateProfile,
    getProfileFunctionalities,
    getProfileFunctionalitiesGrouped,
    getProfileFunctionalitiesReport,
};
